import React, { Component } from 'react';
import { Collapse } from 'reactstrap';
import TeamBoxScore from '../components/boxscore_components/TeamBoxScore';
import Header from '../components/header_components/Header';
import './Game.css'

class Game extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            show: false,
        };
    }

    toggle() {
        this.setState(state => ({ show: !state.show }));
    }

    render() {
        return (
            <div className="entireGame">
                <div className="clickable" onClick={() => { if (this.props.status_num !== 1) this.toggle() }}>
                    <Header
                        vTeamAbb={this.props.v_team.tri_code}
                        hTeamAbb={this.props.h_team.tri_code}
                        vTeamName={this.props.v_team.name}
                        hTeamName={this.props.h_team.name}
                        vTeamScore={this.props.v_team.score}
                        hTeamScore={this.props.h_team.score}
                        period={this.props.period}
                        isGameActivated={this.props.is_game_activated}
                        status_num={this.props.status_num}
                        game_text={this.props.game_text}
                        start_time={this.props.start_time_eastern}
                        clock={this.props.clock}
                    />
                </div>
                <Collapse isOpen={this.state.show}>
                    <TeamBoxScore {...this.props.v_team} />
                    <TeamBoxScore {...this.props.h_team} />
                </Collapse>
            </div>
        );
    }
}

export default Game;
